module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-boost-32.9bcab028.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-boost-32.png
// module id = 3189
// module chunks = 11